const clientBase = 'client';

const base = `${clientBase}_echange`;
const echangeCreate = `${base}-create`;
const echangeShow = `${base}-show`;
const echangeShowDocument = `${base}-show_document`;
const echangeEdit = `${base}-edit`;
const echangeEditDocument = `${base}-edit_document`;

const basePath = '/' + clientBase + '/echange';

export default {
  basePath,
  base,
  create: echangeCreate,
  show: echangeShow,
  showDocument: echangeShowDocument,
  edit: echangeEdit,
  editDocument: echangeEditDocument,
};
